import { axiosInstance } from ".."

const requestForm = async (id) =>{

    return new Promise(async (resolve,reject)=>{
        axiosInstance.post(`internal/form/${id}`).then((res) => { 
            if(res.status === 200){
                return resolve(res)
            }
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
}

export default requestForm;